import React from 'react';
import clsx from 'clsx';
import styles from './DashboardCard.module.css';

export interface DashboardCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const DashboardCard: React.FC<DashboardCardProps> = ({ className, children, ...props }) => {
  return (
    <div className={clsx(styles.dashboardCard, className)} {...props}>
      {children}
    </div>
  );
};

export default DashboardCard;
